export const SHOPKART_BACKEND_URI = "https://shopkart-backend.herokuapp.com/";
export const RAZORPAY_SECRET = "JVtYa3h3TDR7p7baNrDj6p4H";
export const RAZORPAY_KEY_ID = "rzp_test_fUqiLDsBaH0KAr";
